module.exports = __webpack_public_path__ + "img/logo-UMCP.a7c9fe32.svg";